const paymentStatusCodes = [
    { value: '', label: 'Tümü' },
    { value: '1', label: 'Başarılı Ödemeler' },
    { value: '0', label: 'Hatalı Ödemeler' },
    { value: '2', label: 'İade Edilenler' },
    { value: '3', label: 'Kısmi İade Edilenler' },
]


export default paymentStatusCodes;